import $ from "jquery";
import "datatables.net";
import "datatables.net-rowreorder-dt";
import 'bootstrap-icons/font/bootstrap-icons.css';
var dataTable;
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forDownloadIndex")
        return;
    initDataTable();
    $('.accordion .btn[data-bs-toggle="collapse"]').each(function () {
        var $button = $(this);
        var targetId = $button.data('bs-target');
        var $target = $(targetId);
        var $icon = $button.find('.toggle-icon');
        var updateIcon = function () {
            if ($target.hasClass('show')) {
                $icon.removeClass('bi-plus-lg').addClass('bi-dash-lg');
            }
            else {
                $icon.removeClass('bi-dash-lg').addClass('bi-plus-lg');
            }
        };
        // Nastav ikonu podľa aktuálneho stavu
        updateIcon();
        // Zaregistruj eventy
        $target.on('shown.bs.collapse', updateIcon);
        $target.on('hidden.bs.collapse', updateIcon);
    });
});
function initDataTable() {
    dataTable = $('#tableForDownload').DataTable({
        ordering: true,
        columnDefs: [
            {
                target: 0,
                visible: false,
                searchable: false
            },
            {
                target: 1,
                visible: false
            },
            { 'orderable': false, 'targets': [1, 2, 3] }
        ],
        language: {
            info: 'Strana _PAGE_ z _PAGES_',
            infoEmpty: 'Žiadne údaje',
            infoFiltered: '(filtrované z _MAX_ celkových záznamov)',
            lengthMenu: 'Zobraziť _MENU_ záznamov na stránku',
            zeroRecords: 'Nič sa nenašlo',
            search: 'Hľadať:'
        }
    });
}
//# sourceMappingURL=forDownloadIndex.js.map